import { useCallback, useContext } from 'react';

import { CreditCardFormDispatchContext } from '../CreditCardFormProvider';

const useResetCreditCardForm = () => {
  const dispatch = useContext(CreditCardFormDispatchContext);

  return useCallback(() => {
    dispatch.setNameOnCard('');
    dispatch.setNameOnCardError(undefined);
    dispatch.setGeneralStripeError(undefined);
    dispatch.setCardNumberError(undefined);
    dispatch.setCardExpiryError(undefined);
    dispatch.setCardCvcError(undefined);
    dispatch.setCardPostalCodeError(undefined);
  }, [dispatch]);
};

export default useResetCreditCardForm;
